const leadFields = ['lead_name', 'lead_type', 'company_name', 'phone', 'email', 'website',
  'country', 'address', 'priority', 'status', 'lead_source_id', 'assigned_owner_id', 'notes', 'tags'];

// Detail responses contain identities and relationships; send only edited form fields.
export function leadUpdatePayload(form, original) {
  return Object.fromEntries(leadFields.filter(key => Object.prototype.hasOwnProperty.call(form, key)
    && JSON.stringify(form[key]) !== JSON.stringify(original?.[key])).map(key => [key, form[key]]));
}

export function proposalLinePayload(lines) {
  return lines.filter(line => line.description).map(line => {
    const quantity = Number(line.quantity);
    const unitPrice = Number(line.unit_price);
    const percentage = Number(line.discount_percent || 0);
    if (![quantity, unitPrice, percentage].every(Number.isFinite) || quantity <= 0 || unitPrice < 0 || percentage < 0 || percentage > 100) {
      throw new Error('Check the quantity, price and discount for each proposal line.');
    }
    return { description: line.description, quantity, unit_price: unitPrice,
      discount: Math.round(quantity * unitPrice * percentage) / 100 };
  });
}
